// tslint:disable-next-line:directive-selector
import {Directive, ElementRef, HostListener, Input, OnInit, Renderer} from '@angular/core';
import {MatSnackBar} from "@angular/material/snack-bar";

@Directive({selector: '[myFocusGuiaRemision]'})
// tslint:disable-next-line:directive-class-suffix
export class FocusDirectiveGuiaRemision implements OnInit {

    // tslint:disable-next-line:no-input-rename
    @Input('myFocusGuiaRemision') isFocused: boolean;

    constructor(private hostElement: ElementRef, private renderer: Renderer) {
    }

    ngOnInit() {
        if (this.isFocused) {
            this.renderer.invokeElementMethod(this.hostElement.nativeElement, 'focus');
        }

    }
}

@Directive({selector: '[placa]'})
// tslint:disable-next-line:directive-class-suffix
export class FormatPlacaGuiaRemision {

    @Input() placa: boolean;
    regexStr = '^[0-9A-Za-z]*$';


    constructor(private hostElement: ElementRef, private snackBar: MatSnackBar) {
    }

    @HostListener('blur', ['$event']) onBlur(event) {
        const e = <KeyboardEvent>event;
        const regEx = new RegExp(this.regexStr);
        if (this.placa) {
            if (regEx.test(this.hostElement.nativeElement.value)) {
                return;
            } else {
                this.hostElement.nativeElement.value = '';
                this.snackBar.open('formato invalido, Solo numeros y letras', null, {duration: 2000});
            }
            if (this.hostElement.nativeElement.value.length >= 6) {
                this.hostElement.nativeElement.value = this.hostElement.nativeElement.value.toUpperCase();
            } else {
                this.hostElement.nativeElement.value = '';
                this.snackBar.open('Minimo 6 caracteres', null, {duration: 2000});
            }
        }
    }
}

@Directive({selector: '[licencia]'})
// tslint:disable-next-line:directive-class-suffix
export class FormatLicenciaGuiaRemision {

    @Input() licencia: boolean;
    regexStr = '^[0-9A-Za-z]*$';


    constructor(private hostElement: ElementRef, private snackBar: MatSnackBar) {
    }


    @HostListener('blur', ['$event']) onBlur(event) {
        const regEx = new RegExp(this.regexStr);
        const e = <KeyboardEvent>event;
        if (this.licencia) {
            if (regEx.test(this.hostElement.nativeElement.value)) {
                return;
            } else {
                this.hostElement.nativeElement.value = '';
                this.snackBar.open('formato invalido, Solo numeros y letras', null, {duration: 2000});
            }
            if (this.hostElement.nativeElement.value.length >= 9) {
                this.hostElement.nativeElement.value = this.hostElement.nativeElement.value.toUpperCase();
            } else {
                this.hostElement.nativeElement.value = '';
                this.snackBar.open('Minimo 9 caracteres', null, {duration: 2000});
            }
            if (this.hostElement.nativeElement.value === '000000000' ||
                this.hostElement.nativeElement.value === '0000000000') {
                this.hostElement.nativeElement.value = '';
                this.snackBar.open('no puede ser puros 0, coloca un numero de licencia valido', null, {duration: 2000});
            }
        }
    }
}


@Directive({selector: '[documento]'})
// tslint:disable-next-line:directive-class-suffix
export class FormatDocumentoGuiaRemision {

    @Input() documento: boolean;
    @Input() tipo = '6';
    regexStr = '^[0-9A-Za-z]*$';


    constructor(private hostElement: ElementRef, private snackBar: MatSnackBar) {
    }

    @HostListener('blur', ['$event']) onBlur(event) {
        const e = <KeyboardEvent>event;
        const regEx = new RegExp(this.regexStr);

        const size = this.getSize();
        if (this.documento) {
            if (regEx.test(this.hostElement.nativeElement.value)) {
                if (this.hostElement.nativeElement.value.length === size) {
                    this.hostElement.nativeElement.value = this.hostElement.nativeElement.value.toUpperCase();
                } else {
                    this.hostElement.nativeElement.value = '';
                    this.snackBar.open('debe tener ' + size + ' caracteres', null, {duration: 2000});
                }
                if (this.hostElement.nativeElement.value === '000000000' ||
                    this.hostElement.nativeElement.value === '0000000000') {
                    this.hostElement.nativeElement.value = '';
                    this.snackBar.open('no puede ser puros 0, coloca un numero de licencia valido', null, {duration: 2000});
                }
            } else {
                this.hostElement.nativeElement.value = '';
                this.snackBar.open('formato invalido, Solo numeros y letras', null, {duration: 2000});
            }
        }
    }

    getSize() {
        let size = 15;
        if ('1' === this.tipo) {
            size = 8;
            return size;
        }
        if ('6' === this.tipo) {
            size = 11;
            return size;
        }
        return size;
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/guia-remision/guia-remision.directive.ts